/* eslint-disable no-console */
import {Flex} from 'antd';
import React from 'react';

import {TF} from '../../../constants/Common';
import {formatIndian} from '../../../utils/formatIndian';
import {AllCap} from '../../../utils/FormUtils/FirstCap';
import sumValue from '../../Table/Utils/sumValue';
import breakCamelCase from '../Utils/breakCamelCase';

const DisposalDisplay: React.FC<{
  disposalModalData: any[];
  disposalModalType: string;
  disposalKey: string;
}> = ({disposalModalData, disposalModalType, disposalKey}) => {
  return (
    <Flex justify="space-between" wrap="wrap" gap={30}>
      {disposalModalData?.map((item: any, index: number) => {
        const singleItem = item?.[TF]?.filter((item: any) => {
          return item.type === disposalModalType;
        })?.[0];

        return (
          <div
            // span={Math.floor(24 / disposalModalData.length)}
            key={index}
          >
            <div>
              {/* {singleItem?.type === 'cost' ||
              singleItem?.type === 'treatmentCost'
                ? `${singleItem?.unit} ${formatIndian(
                    sumValue(singleItem?.data)
                  )}`
                : `${formatIndian(
                    sumValue(singleItem?.data)
                  )} ${singleItem?.unit}`} */}
              {formatIndian(sumValue(singleItem?.data))}
            </div>
            <div
              style={{
                font: 'normal 600 12px/15px Montserrat',
                color: '#677489'
              }}
            >
              {AllCap(breakCamelCase(item?.[disposalKey]))}
            </div>
          </div>
        );
      })}
    </Flex>
  );
};

export default DisposalDisplay;
